export const DEFAULT_POLL_TIME = 60000;
export const MINIMUM_POLL_TIME = 30000;
export const FLAG_CACHE_EXPIRY_MINUTES = 5;